import { render, staticRenderFns } from "./RipeavRightGo.vue?vue&type=template&id=219dee56&scoped=true&"
import script from "./RipeavRightGo.vue?vue&type=script&lang=js&"
export * from "./RipeavRightGo.vue?vue&type=script&lang=js&"
import style0 from "./RipeavRightGo.vue?vue&type=style&index=0&id=219dee56&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219dee56",
  null
  
)

export default component.exports